"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var removeEmptyKeys = function removeEmptyKeys(data) {
  var result = Object.keys(data).reduce(function (prev, key) {
    var value = data[key];
    var isArray = Array.isArray(value);
    var isObject = _typeof(value) === 'object' && !isArray && !!value;
    var isUndefined = typeof value === 'undefined';
    var isNotValidString = typeof value === 'string' && !value.trim();
    var isNotValidArray = isArray && !value.length;
    var isNotValidObject = isObject && !Object.keys(value).length;
    var isNotValid = isUndefined || isNotValidString || isNotValidArray || isNotValidObject;
    if (isNotValid) return prev;
    if (isArray) {
      var nestedArray = value.map(function (element) {
        return _typeof(element) === 'object' && !Array.isArray(element) ? removeEmptyKeys(element) : element;
      });
      prev[key] = nestedArray;
    } else if (isObject) {
      var nestedObject = removeEmptyKeys(value);
      var isEmptyObject = Object.keys(nestedObject).length === 0;
      if (!isEmptyObject) prev[key] = nestedObject;
    } else prev[key] = value;
    return prev;
  }, {});
  return result;
};
var _default = exports["default"] = removeEmptyKeys;